class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances =
      document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
    
  }
  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    console.log("focus out")
    // setTimeout(() => {
    //   if (!this.contains(document.activeElement)) this.close();
    // })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]"
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(
      this.querySelectorAll("li, button.predictive-search__item")
    ).filter((element) => element.offsetParent !== null);
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );

    if (selectedOption) selectedOption.click();
  }

  supportPredictiveApi() {
    const searchModal = document.querySelector('.search-modal');
    if (searchModal && searchModal.classList.contains('predictive_api_enabled')) {
      const shopifyFeatureRequests = JSON.parse(document.getElementById("shopify-features").innerHTML);
      return shopifyFeatureRequests["predictiveSearch"];
    }
    return false;
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    if(this.supportPredictiveApi()) {
      fetch(
        `${routes.predictive_search_url}?q=${encodeURIComponent(
          searchTerm
        )}&section_id=predictive-search`,
        { signal: this.abortController.signal }
      )
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          // Save bandwidth keeping the cache in all instances synced
          this.allPredictiveSearchInstances.forEach(
            (predictiveSearchInstance) => {
              predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
            }
          );
          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          if (error?.code === 20) {
            // Code 20 means the call was aborted
            return;
          }
          this.close();
          throw error;
        });
    } else {
      fetch(
        `${window.Shopify.routes.root}search?q=${encodeURIComponent(
          searchTerm
        )}&section_id=predictive-search-compatibility&type=product&options[unavailable_products]=last&options[prefix]=last`,
        { signal: this.abortController.signal }
      )
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search-compatibility').innerHTML;
          // Save bandwidth keeping the cache in all instances synced
          this.allPredictiveSearchInstances.forEach(
            (predictiveSearchInstance) => {
              predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
            }
          );
          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          if (error?.code === 20) {
            // Code 20 means the call was aborted
            return;
          }
          this.close();
          throw error;
        });
    }
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }
  
  getColorOptionsCached() {
    const BASE_URL = 'https://shopify-otech.matat.io/api/metaobjects/all';
    const CACHE_KEY = 'color_metaobjects_cache';
    const CACHE_TTL = 1000 * 60 * 10; // 10 minutes
  
    const now = Date.now();
    const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');
  
    if (cached.data && cached.timestamp && (now - cached.timestamp < CACHE_TTL)) {
      applyColorOptions(cached.data);
    } else {
      // Recursive fetch for all pages
      const allMetaobjects = [];
  
      const fetchAllPages = async (page = 1) => {
        const url = `${BASE_URL}?shop_domain=new-dreadlocks.myshopify.com&type=add_color_options&page=${page}`;
        const response = await fetch(url, { headers: { 'Content-Type': 'application/json' } });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        const metaobjects = data.data?.metaobjects || [];
  
        allMetaobjects.push(...metaobjects);
  
        // If less than 100 items, it's the last page
        if (metaobjects.length === 100) {
          return fetchAllPages(page + 1);
        } else {
          return allMetaobjects;
        }
      };
  
      fetchAllPages()
        .then((allData) => {
          localStorage.setItem(CACHE_KEY, JSON.stringify({
            data: allData,
            timestamp: Date.now()
          }));
          applyColorOptions(allData);
        })
        .catch(error => {
          console.error('Fetch error:', error);
          if (cached.data) {
            console.warn('Using stale cached data due to fetch error.');
            applyColorOptions(cached.data);
          }
        });
    }
  
    function applyColorOptions(metaobjects) {
      console.log("metaobjects", metaobjects);
      const colorMap = new Map();
      for (const obj of metaobjects) {
        const key = obj.displayName?.trim().toLowerCase();
        if (key) colorMap.set(key, obj.fields);
      }
  
      const items = document.querySelectorAll('.variation-item');
      const updates = [];
  
      items.forEach((item) => {
        const colorName = item.querySelector("input[type='radio']")?.getAttribute('data-sku')?.trim();
        const colorcode = colorName?.split("--")[1]?.toLowerCase(); // ensure match by lowercasing
        console.log("colorName", colorcode);
        const span = item.querySelector('.variation-item-span');
        if (!colorcode || !span) return;
  
        const fields = colorMap.get(colorcode);
        console.log("fields", fields);
        if (fields) {
          updates.push(() => {
            const colorImage = fields.color_image?.url;
            const colorCode = fields.color_code;
            if (colorImage) {
              span.style.backgroundImage = `url(${colorImage})`;
              span.style.backgroundSize = 'cover';
              span.style.backgroundPosition = 'center';
            } else if (colorCode) {
              span.style.backgroundColor = colorCode;
            }
          });
        }
      });
  
      requestAnimationFrame(() => {
        for (const update of updates) update();
      });
    }
  }

  sliderCall(){
    if(document.querySelector('predictive-search .flickity_grid')){
        var carousel = document.querySelectorAll('predictive-search .flickity_grid');
        var flkty;
        carousel.forEach((slide) => {
            flkty = new Flickity(slide, {
             "imagesLoaded": true,
              "rightToLeft": true,
              "cellAlign": "right",
              "pageDots": false,
              "wrapAround": true,
              "draggable": false,
              "prevNextButtons": false,
              "fade":true,
              "responsive": [
                {
                  "breakpoint": 750,
                  "settings": {
                    "freeScroll": true,
                    "wrapAround": false,
                    "contain": true,
                    "prevNextButtons": false,
                    "draggable": false,
                    "pageDots": false
                  }
                }
              ]
          });
        })  
      }
    if(this.querySelector('.card-variation-color')){
      const colorInputs = this.querySelectorAll('.card-variation-color input:checked');
      colorInputs.forEach(input => {
        ProductCardColor(input);
      });                 
    }
    
  }
  
  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    console.log("resultsMarkup",resultsMarkup)
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);
    this.setLiveRegionResults();
    setTimeout(() => {
      this.sliderCall();
    }, 300);
    this.getColorOptionsCached()
    
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    this.closest(".search-modal__content").classList.add("result-show");
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.closest(".search-modal__content").classList.remove("result-show");
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
